import axios from 'axios';

// ApiCore pode resolver a promise com o erro: preserve-o antes de ler data ou anunciar sucesso.
export default function requireSuccessfulResponse(response: any): void {
  if (response instanceof Error || axios.isAxiosError(response) || response?.response) {
    throw response;
  }
  if (response?.status >= 400 || response?.data?.success === false) {
    throw Object.assign(new Error(response.data?.message || 'Request failed'), { response });
  }
}
